module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADkSURBVHgB5ZPPDYIwFId/Bb0zApoYNfHiBDIC4gJu4Aq6gRu4QYMTyAjcCF7EDbibtBYwECiC/Ikx8Ts0r32vX9r0Ffh1SBptrjswmGgDIQ7o5JAJTc+AolzQBfZYwl64g8JyCMbWaIKinMSoA6oWTWWhPXfQBMvP+9Ezfygc1FZY/g3xK8YEoNNRNyHggpMgjgiCuuKiUBNNvs2tMHZOYw5I+WiPLFTDpFokk0ZtTfaXLW8Prq7Kq7jxOqErJqGcF7egs2NeWIXl8yQY6qDjOz46YaWoyHvxl/uQsfKes6uv3StPX3s50y7JBR0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/prow2.png
// module id = uBsY
// module chunks = 0